if (document.querySelector('.mysplide')) {
  var splide = new Splide('.mysplide', {
    type: 'loop',       // Optional: makes it loop
    pagination: true,   // Show dots
    arrows: true        // Optional: show arrows
  });

  splide.mount();

  window.addEventListener('load', function () {
    gsap.to(".head-line", {
      width: "100%",
      opacity: 1,
      duration: 1.2,
      ease: "power2.out"
    });
  });
}




 gsap.registerPlugin(ScrollTrigger);

//   const image = document.querySelector('.text-line');

//   gsap.to(image, {
//     maxWidth: 185,
//     scrollTrigger: {
//       trigger: image,
//       start: "top 70%", 
//       end: "top 70%",
//       scrub: 1,
//       markers: true 
//     }
//   });

const image_scale = document.querySelectorAll('.text-left img.head-line');

image_scale.forEach((img) => {
  gsap.to(img, {
    rotation: -21,
    scale: 1,
    scrollTrigger: {
      trigger: img,
      start: "top 85%",
      end: "top 85%",
      scrub: 1,
      // markers: true
    }
  });
});


  const image_span = document.querySelector('.span_img');

  gsap.to(image_span, {
    scale: 1,
    scrollTrigger: {
      trigger: image_span,
      start: "top 85%", 
      end: "top 85%",
      scrub: 1,
      // markers: true 
    }
  });


  gsap.from(".gradient-img-text_media", {
    x: 100,             
    opacity: 0,       
    duration: 1,     
    ease: "power3.out", 
    scrollTrigger: {
      trigger: ".gradient-img-text", 
      start: "top 80%",       
      toggleActions: "play none none reverse" 
    }
  });

  gsap.from(".ct-newsletter_media", {
    x: -100,             
    opacity: 0,       
    duration: 1,     
    ease: "power3.out", 
    scrollTrigger: {
      trigger: ".ct-newsletter", 
      start: "top 80%",       
      toggleActions: "play none none reverse" 
    }
  });

  gsap.from(".gradient-img-text-2_media img.gradient_media", {
    scaleX: 0,          // start at zero width
    duration: 1,
    ease: "power3.out",
    scrollTrigger: {
      trigger: ".gradient-img-text-2",
      start: "top 80%",
      toggleActions: "play none none reverse"
    }
  });

  // gsap.set(".imgblock_2.imgblock", { clipPath: "inset(100% 0 0 0)" });
  // gsap.to(".imgblock_2.imgblock", {
  //   clipPath: "inset(0% 0 0 0)", // fully revealed
  //   ease: "none",
  //   scrollTrigger: {
  //     trigger: ".about-img_text",
  //     start: "top top",
  //     end: "+=500",
  //     scrub: true,
  //     pin: true
  //   }
  // });

  gsap.set(".imgblock", { scale: 1, opacity: 1, zIndex: 2 });
  gsap.set(".imgblock_2", { scale: 0.8, opacity: 0, zIndex: 1 });

  gsap.timeline({
    scrollTrigger: {
      trigger: ".about-img_text",
      start: "top top",
      end: "+=500",
      scrub: true,
      pin: true
    }
  })
  .to(".imgblock", {
    scale: 0.8,
    opacity: 0,
    ease: "none"
  }, 0)
  .to(".imgblock_2", {
    scale: 1,
    opacity: 1,
    ease: "none"
  }, 0);

  //  const sections = document.querySelectorAll('.pro_info-main');

  // sections.forEach(section => {
  //   const badge = section.querySelector('.pro_info_badge');

  //   if (badge) {
  //     gsap.to(badge, {
  //       scale: 1,
  //       duration: 0.5,
  //       ease: "power2.out",
  //       scrollTrigger: {
  //         trigger: section,
  //         start: "top 90%",  
  //         toggleActions: "play none none none",
  //         // markers: true 
  //       }
  //     });
  //   }
  // });


const sections = document.querySelectorAll('.pro_info-main');

sections.forEach((section, index) => {
  const badge = section.querySelector('.pro_info_badge');

  if (badge) {
    gsap.to(badge, {
      scale: 1,
      duration: 0.5,
      delay: index * 0.2, // delay each badge based on its index
      ease: "power2.out",
      scrollTrigger: {
        trigger: section,
        start: "top 90%",
        toggleActions: "play none none none",
        // markers: true
      }
    });
  }
});


/* Anchor Scrolling */
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelectorAll('a[href^="#"]').forEach(a => a.classList.remove('active'));
        this.classList.add('active');
        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});



/** Product Page Media Gallery Custom Dots **/
document.addEventListener('DOMContentLoaded', function () {
  const mediaGallery = document.querySelector('media-gallery');
  const mediaList = document.querySelector('.product__media-list');
  const dots = document.querySelectorAll('.ct-main-product .dot');

  if (!mediaGallery || !mediaList || !dots.length) return;

  function setActiveDot(index) {
    document.querySelector('.dot.active')?.classList.remove('active');
    const dot = document.querySelector(`.dot[data-index="${index}"]`);
    dot?.classList.add('active');
  }

  // Click on dots
  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      const index = parseInt(dot.dataset.index);
      const offset = mediaList.children[index].offsetLeft;

      mediaList.scrollTo({
        left: offset,
        behavior: 'smooth'
      });

      setActiveDot(index);
    });
  });

  // Detect image change via arrow/thumb/keyboard
  const observer = new MutationObserver(() => {
    const activeMedia = mediaList.querySelector('[media-id][aria-current="true"]');
    if (!activeMedia) return;

    const index = Array.from(mediaList.children).indexOf(activeMedia);
    if (index > -1) setActiveDot(index);
  });

  observer.observe(mediaList, { attributes: true, subtree: true, attributeFilter: ['aria-current'] });

  // Optional: update on scroll (e.g., mobile swipe)
  mediaList.addEventListener('scroll', () => {
    const scrollLeft = mediaList.scrollLeft;
    const childWidth = mediaList.children[0].clientWidth;

    const index = Math.round(scrollLeft / childWidth);
    setActiveDot(index);
  });
});


/* Flip card toggle — vanilla JS (no jQuery dependency) */
document.querySelectorAll('.ct-flip-card_item').forEach(function(el) {
  el.addEventListener('click', function() { this.classList.toggle('active'); });
});
document.querySelectorAll('.flip-image_wrp').forEach(function(el) {
  el.addEventListener('click', function() { this.classList.toggle('active'); });
});






// var splide = new Splide( '.cart_product_list', {
//   arrows: false,
//   pagination: false,
//   perPage: 3,
//   rewind : true,
// } );

// splide.mount();

let cart_splide;
function initCartSplide() {
  // Destroy previous instance only if it exists
  if (cart_splide) {
    try { cart_splide.destroy(); } catch(e) {}
    cart_splide = null;
  }
  const slider = document.querySelector('.cart_product_list');
  if (!slider) return;
  cart_splide = new Splide(slider, {
    arrows: false,
    pagination: false,
    perPage: 3,
    rewind: true,
    autoWidth: true,
  });
  cart_splide.mount();
}
initCartSplide();

if (document.body.clientWidth > 750) {
// gsap.registerPlugin(ScrollTrigger);
// // Set stacking order (z-index)
// gsap.set(".imgblock", {
//   zIndex: (i, target, targets) => targets.length - i
// });
// var images = gsap.utils.toArray(".imgblock:not(:last-of-type)");
// // Loop through all images except the last one
// images.forEach((image, i) => {
//   var tl = gsap.timeline({
//     scrollTrigger: {
//       trigger: ".about-img_text_wrp",
//       start: () => "top -" + window.innerHeight * (i + 0.5),
//       end: () => "+=" + window.innerHeight,
//       scrub: true,
//       toggleActions: "play none reverse none",
//       invalidateOnRefresh: true
//     }
//   });
//   // Instead of shrinking height, fade out
//   tl.to(image, {
//     opacity: 0,
//     pointerEvents: "none",
//     duration: 1
//   });
// });
// // Master ScrollTrigger to pin the whole section
// ScrollTrigger.create({
//   trigger: ".about-img_text_wrp",
//   scrub: true,
//   // markers: true,
//   pin: true,
//   start: () => "top top",
//   end: () => "+=" + (images.length + 1) * window.innerHeight,
//   invalidateOnRefresh: true
// });
}

if (document.body.classList.contains("ct_template_recipe")) {
var recipe_slider = new Splide( '.recipe-slider', {
  classes: {
		prev  : 'splide__arrow--prev',
		next  : 'splide__arrow--next',
  },
  arrows: true,
  perPage: 3,
  rewind : true,
  pagination: false,
  breakpoints: {
    989: {
      perPage: 2
    },
    749: {
      perPage: 1,
      arrows: false,
      pagination: true
    },
  },
});
recipe_slider.mount();

var recipe_slider2 = new Splide( '.recipe-slider-section2 .recipe-slider', {
  classes: {
		prev  : 'recipe-slider_arw_2 splide__arrow--prev',
		next  : 'recipe-slider_arw_2 splide__arrow--next',
  },
  arrows: true,
  perPage: 3,
  rewind : true,
  pagination: false,
  breakpoints: {
    989: {
      perPage: 2
    },
    749: {
      perPage: 1,
      arrows: false,
      pagination: true
    },
  },
});
recipe_slider2.mount();

var recipe_slider3 = new Splide( '.recipe-slider-section3 .recipe-slider', {
  classes: {
		prev  : 'recipe-slider_arw_3 splide__arrow--prev',
		next  : 'recipe-slider_arw_3 splide__arrow--next',
  },
  arrows: true,
  perPage: 3,
  rewind : true,
  pagination: false,
  breakpoints: {
    989: {
      perPage: 2
    },
    749: {
      perPage: 1,
      arrows: false,
      pagination: true
    },
  },
});
recipe_slider3.mount();
}
if (document.body.clientWidth < 750) {
if (document.querySelector('.product-grid-container #product-grid')){
document.addEventListener("DOMContentLoaded", function(){
  const ul = document.querySelector('.product-grid-container #product-grid');
  if(!ul) return;

  const items = Array.from(ul.children);
  const perRow = 4;
  const parent = ul.parentNode;

  // Purana UL hatao
  parent.removeChild(ul);

  for(let i = 0; i < items.length; i += perRow){
    const group = items.slice(i, i + perRow);

    const row = document.createElement('div');
    row.classList.add('product-slider-row');

    const rowUl = document.createElement('ul');
    rowUl.classList.add('product-slider');
    rowUl.setAttribute('role', 'list');

    group.forEach(item => rowUl.appendChild(item));
    row.appendChild(rowUl);
    parent.appendChild(row);
  }
});
}
}


/* Product page cart drawer + GoKwik — vanilla JS (no jQuery dependency) */
document.addEventListener('click', function(e) {
  if (e.target.closest('.ct_template_page_product .header__icon--cart')) {
    var btn = document.querySelector('.shipping_cart_open');
    if (btn) btn.click();
  }
  if (e.target.closest('.ct_template_page_product .shipping_cart_open')) {
    document.body.classList.add('cart_drawer_pdp');
  }
  if (e.target.closest('.ct_template_page_product .cart-drawer__overlay')) {
    document.body.classList.remove('cart_drawer_pdp');
    var drawer = e.target.closest('cart-drawer');
    if (drawer) drawer.classList.add('active');
  }
  if (e.target.closest('.gokwik-checkout')) {
    var closeBtn = document.querySelector('.drawer__close');
    if (closeBtn) closeBtn.click();
  }
});
